import type { EntityAdapter, EntityState } from '@ngrx/entity';
import type { Action } from '@ngrx/store';
import type { CourierOutput } from 'core/http/root';
import { createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import * as CouriersActions from './couriers.actions';

export interface RootCouriersState extends EntityState<CourierOutput> {
  isLoaded: boolean;
}

const adapter: EntityAdapter<CourierOutput> = createEntityAdapter();

export const initialRootCouriersState = adapter.getInitialState<RootCouriersState>({
  isLoaded: false,
});

const reducer = createReducer(
  initialRootCouriersState,
  on(CouriersActions.saveRootCouriers, (state, { couriers }) => adapter.addMany(couriers, state)),
  on(CouriersActions.markRootCouriersLoaded, state => ({ ...state, isLoaded: true })),
  on(CouriersActions.updateCourierExtensionProjectsInStore, (state, { update }) => adapter.updateOne(update, state)),
);

export function rootCouriersReducer(state: RootCouriersState | undefined, action: Action): RootCouriersState {
  return reducer(state, action);
}

export const {
  selectAll,
} = adapter.getSelectors();
